import 'iframe-resizer/js/iframeResizer.contentWindow';
import './styles.fractal.scss';

// eslint-disable-next-line
import * as components from '.';

module.exports = {
    ...components,
};
